(function(f){if(typeof exports==="object"&&typeof module!=="undefined"){module.exports=f()}else if(typeof define==="function"&&define.amd){define([],f)}else{var g;if(typeof window!=="undefined"){g=window}else if(typeof global!=="undefined"){g=global}else if(typeof self!=="undefined"){g=self}else{g=this}g.BugsnagPluginAwsLambda = f()}})(function(){var define,module,exports;
var _$pad_5 = function pad(num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};

/* removed: var _$pad_5 = require('./pad.js'); */;

var os = require("os"),
    padding = 2,
    pid = _$pad_5(process.pid.toString(36), padding),
    hostname = os.hostname(),
    length = hostname.length,
    hostId = _$pad_5(hostname.split('').reduce(function (prev, char) {
  return +prev + char.charCodeAt(0);
}, +length + 36).toString(36), padding);

var _$fingerprint_4 = function fingerprint() {
  return pid + hostId;
};

/**
 * cuid.js
 * Collision-resistant UID generator for browsers and node.
 * Sequential for fast db lookups and recency sorting.
 * Safe for element IDs and server-side lookups.
 *
 * Extracted from CLCTR
 *
 * Copyright (c) Eric Elliott 2012
 * MIT License
 */
/* removed: var _$fingerprint_4 = require('./lib/fingerprint.js'); */;

/* removed: var _$pad_5 = require('./lib/pad.js'); */;

var c = 0,
    blockSize = 4,
    base = 36,
    discreteValues = Math.pow(base, blockSize);

function randomBlock() {
  return _$pad_5((Math.random() * discreteValues << 0).toString(base), blockSize);
}

function safeCounter() {
  c = c < discreteValues ? c : 0;
  c++; // this is not subliminal

  return c - 1;
}

function cuid() {
  // Starting with a lowercase letter makes
  // it HTML element ID friendly.
  var letter = 'c',
      // hard-coded allows for sequential access
  // timestamp
  // warning: this exposes the exact date and time
  // that the uid was created.
  timestamp = new Date().getTime().toString(base),
      // Prevent same-machine collisions.
  counter = _$pad_5(safeCounter().toString(base), blockSize),
      // A few chars to generate distinct ids for different
  // clients (so different computers are far less
  // likely to generate the same id)
  print = _$fingerprint_4(),
      // Grab some more chars from Math.random()
  random = randomBlock() + randomBlock();
  return letter + timestamp + counter + print + random;
}

cuid.fingerprint = _$fingerprint_4;
var _$cuid_3 = cuid;

/* removed: var _$cuid_3 = require('@bugsnag/cuid'); */;

var FLUSH_POLL_INTERVAL_MS = 50;
var inFlightRequests = new Map();

var noop = function () {};

var _$inFlight_6 = {
  trackInFlight: function (client) {
    var originalNotify = client._notify;

    client._notify = function (event, onError, callback) {
      if (callback === void 0) {
        callback = noop;
      }

      var id = _$cuid_3();
      inFlightRequests.set(id, true);

      var _callback = function () {
        inFlightRequests["delete"](id);
        callback.apply(null, arguments);
      };

      client._depth += 1;

      try {
        originalNotify.call(client, event, onError, _callback);
      } finally {
        client._depth -= 1;
      }
    };

    var patchDelivery = function (delivery) {
      var originalSendSession = delivery.sendSession;

      delivery.sendSession = function (session, callback) {
        if (callback === void 0) {
          callback = noop;
        }

        var id = _$cuid_3();
        inFlightRequests.set(id, true);

        var _callback = function () {
          inFlightRequests["delete"](id);
          callback.apply(null, arguments);
        };

        originalSendSession.call(delivery, session, _callback);
      };
    };

    var delivery = client._delivery;
    patchDelivery(delivery); // ensure we also monkey-patch any new delivery that might be set

    Object.defineProperty(client, '_delivery', {
      get: function () {
        return delivery;
      },
      set: function (newDeliviery) {
        patchDelivery(newDeliviery);
        delivery = newDeliviery;
      }
    });
  },
  flush: function (timeoutMs) {
    return new Promise(function (resolve, reject) {
      var resolveTimeout;
      var rejectTimeout = setTimeout(function () {
        if (resolveTimeout) clearTimeout(resolveTimeout);
        reject(new Error("flush timed out after " + timeoutMs + "ms"));
      }, timeoutMs);

      var resolveIfNoRequests = function () {
        if (inFlightRequests.size === 0) {
          clearTimeout(rejectTimeout);
          resolve();
          return;
        }

        resolveTimeout = setTimeout(resolveIfNoRequests, FLUSH_POLL_INTERVAL_MS);
      };

      resolveIfNoRequests();
    });
  }
};

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _$lambdaTimeoutApproaching_8 = /*#__PURE__*/function (_Error) {
  _inheritsLoose(LambdaTimeoutApproaching, _Error);

  function LambdaTimeoutApproaching(remainingMs) {
    var _this;

    var message = "Lambda will timeout in " + remainingMs + "ms";
    _this = _Error.call(this, message) || this;
    _this.name = 'LambdaTimeoutApproaching';
    _this.stack = [];
    return _this;
  }

  return LambdaTimeoutApproaching;
}( /*#__PURE__*/_wrapNativeSuper(Error));

// Array#reduce
var _$reduce_2 = function (arr, fn, accum) {
  var val = accum;

  for (var i = 0, len = arr.length; i < len; i++) {
    val = fn(val, arr[i], i, arr);
  }

  return val;
};

/* removed: var _$reduce_2 = require('./reduce'); */; // Array#includes


var _$includes_1 = function (arr, x) {
  return _$reduce_2(arr, function (accum, item, i, arr) {
    return accum === true || item === x;
  }, false);
};

/* removed: var _$includes_1 = require('@bugsnag/core/lib/es-utils/includes'); */;

var _$session_9 = {
  load: function (client) {
    client._sessionDelegate = sessionDelegate;
  }
};
var sessionDelegate = {
  startSession: function (client, session) {
    var sessionClient = client;
    sessionClient._session = session;
    sessionClient._pausedSession = null; // exit early if the current releaseStage is not enabled

    if (sessionClient._config.enabledReleaseStages !== null && !_$includes_1(sessionClient._config.enabledReleaseStages, sessionClient._config.releaseStage)) {
      sessionClient._logger.warn('Session not sent due to releaseStage/enabledReleaseStages configuration');

      return sessionClient;
    }

    sessionClient._delivery.sendSession({
      notifier: sessionClient._notifier,
      device: session.device,
      app: session.app,
      sessions: [{
        id: session.id,
        startedAt: session.startedAt,
        user: session._user
      }]
    });

    return sessionClient;
  },
  resumeSession: function (client) {
    // Do nothing if there's already an active session
    if (client._session) {
      return client;
    } // If we have a paused session then make it the active session


    if (client._pausedSession) {
      client._session = client._pausedSession;
      client._pausedSession = null;
      return client;
    } // Otherwise start a new session


    return client.startSession();
  },
  pauseSession: function (client) {
    client._pausedSession = client._session;
    client._session = null;
  }
};

var _$src_7 = {};
/* removed: var _$inFlight_6 = require('@bugsnag/in-flight'); */;

/* removed: var _$session_9 = require('@bugsnag/plugin-browser-session'); */;

/* removed: var _$lambdaTimeoutApproaching_8 = require('./lambda-timeout-approaching'); */; // JS timers use a signed 32 bit integer for the millisecond parameter. SAM's
// "local invoke" has a bug that means it exceeds this amount, resulting in
// warnings. See https://github.com/aws/aws-sam-cli/issues/2519


var MAX_TIMER_VALUE = Math.pow(2, 31) - 1;
var BugsnagPluginAwsLambda = {
  name: 'awsLambda',
  load: function (client) {
    _$inFlight_6.trackInFlight(client);

    client._loadPlugin(_$session_9); // Reset the app duration between invocations, if the plugin is loaded


    var appDurationPlugin = client.getPlugin('appDuration');

    if (appDurationPlugin) {
      appDurationPlugin.reset();
    } // AWS add a default unhandledRejection listener that forcefully exits the
    // process. This breaks reporting of unhandled rejections, so we have to
    // remove all existing listeners and call them after we handle the rejection


    if (client._config.autoDetectErrors && client._config.enabledErrorTypes.unhandledRejections) {
      var listeners = process.listeners('unhandledRejection');
      process.removeAllListeners('unhandledRejection'); // This relies on our unhandled rejection plugin adding its listener first
      // using process.prependListener, so we can call it first instead of AWS'

      process.on('unhandledRejection', async function (reason, promise) {
        for (var listener of listeners) {
          await listener.call(process, reason, promise);
        }
      });
    }

    return {
      createHandler: function (_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
            _ref$flushTimeoutMs = _ref.flushTimeoutMs,
            flushTimeoutMs = _ref$flushTimeoutMs === void 0 ? 2000 : _ref$flushTimeoutMs,
            _ref$lambdaTimeoutNot = _ref.lambdaTimeoutNotifyMs,
            lambdaTimeoutNotifyMs = _ref$lambdaTimeoutNot === void 0 ? 1000 : _ref$lambdaTimeoutNot;

        return wrapHandler.bind(null, client, flushTimeoutMs, lambdaTimeoutNotifyMs);
      }
    };
  }
};

function wrapHandler(client, flushTimeoutMs, lambdaTimeoutNotifyMs, handler) {
  var _handler = handler;

  if (handler.length > 2) {
    // This is a handler expecting a 'callback' argument, so we convert
    // it to return a Promise so '_handler' always has the same API
    _handler = promisifyHandler(handler);
  }

  return async function (event, context) {
    var lambdaTimeout; // Guard against the "getRemainingTimeInMillis" being missing. This should
    // never happen but could when unit testing

    if (typeof context.getRemainingTimeInMillis === 'function' && lambdaTimeoutNotifyMs > 0) {
      var timeoutMs = context.getRemainingTimeInMillis() - lambdaTimeoutNotifyMs;

      if (timeoutMs <= MAX_TIMER_VALUE) {
        lambdaTimeout = setTimeout(function () {
          var handledState = {
            severity: 'warning',
            unhandled: true,
            severityReason: {
              type: 'log'
            }
          };
          var event = client.Event.create(new _$lambdaTimeoutApproaching_8(context.getRemainingTimeInMillis()), true, handledState, 'aws lambda plugin', 0);
          event.context = context.functionName || 'Lambda timeout approaching';

          client._notify(event);
        }, timeoutMs);
      }
    }

    client.addMetadata('AWS Lambda context', context);

    if (client._config.autoTrackSessions) {
      client.startSession();
    }

    try {
      return await _handler(event, context);
    } catch (err) {
      if (client._config.autoDetectErrors && client._config.enabledErrorTypes.unhandledExceptions) {
        var handledState = {
          severity: 'error',
          unhandled: true,
          severityReason: {
            type: 'unhandledException'
          }
        };

        var _event = client.Event.create(err, true, handledState, 'aws lambda plugin', 1);

        client._notify(_event);
      }

      throw err;
    } finally {
      if (lambdaTimeout) {
        clearTimeout(lambdaTimeout);
      }

      try {
        await _$inFlight_6.flush(flushTimeoutMs);
      } catch (err) {
        client._logger.error("Delivery may be unsuccessful: " + err.message);
      }
    }
  };
} // Convert a handler that uses callbacks to an async handler


function promisifyHandler(handler) {
  return function (event, context) {
    return new Promise(function (resolve, reject) {
      var result = handler(event, context, function (err, response) {
        if (err) {
          reject(err);
          return;
        }

        resolve(response);
      }); // Handle an edge case where the passed handler has the callback parameter
      // but actually returns a promise. In this case we need to resolve/reject
      // based on the returned promise instead of in the callback

      if (isPromise(result)) {
        result.then(resolve)["catch"](reject);
      }
    });
  };
}

function isPromise(value) {
  return (typeof value === 'object' || typeof value === 'function') && typeof value.then === 'function' && typeof value["catch"] === 'function';
}

_$src_7 = BugsnagPluginAwsLambda; // add a default export for ESM modules without interop

_$src_7["default"] = _$src_7;

return _$src_7;

});
//# sourceMappingURL=bugsnag-aws-lambda.js.map
